import { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Lock, LogIn, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { useAuth, formatApiError } from "./AuthContext";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const location = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);

  if (loading) return <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">Yükleniyor...</div>;
  if (user) return <Navigate to={location.state?.from || "/admin"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(form.email, form.password);
      toast.success("Giriş başarılı");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-background grid-bg flex items-center justify-center p-5" data-testid="admin-login-page">
      <div className="absolute -top-32 -right-32 h-[460px] w-[460px] rounded-full bg-primary/15 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -left-32 h-[420px] w-[420px] rounded-full bg-primary/10 blur-3xl pointer-events-none" />

      <div className="relative w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/assets/fcs-logo.png" alt="FCS" className="h-20 w-20 object-contain mx-auto drop-shadow-[0_0_30px_hsl(202_100%_50%/0.5)]" />
          <h1 className="font-display text-3xl font-black uppercase tracking-tight mt-4">Yönetim Paneli</h1>
          <p className="text-sm text-muted-foreground mt-1">Focus Spor Kulübü · FCS</p>
        </div>

        <form onSubmit={submit} className="card-elev p-7 space-y-4" data-testid="admin-login-form">
          <div>
            <label className="label-input">E-posta</label>
            <input
              type="email"
              required
              className="input-base"
              value={form.email}
              onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
              data-testid="login-email"
              autoFocus
            />
          </div>
          <div>
            <label className="label-input flex items-center gap-1.5"><Lock className="h-3 w-3" /> Şifre</label>
            <input
              type="password"
              required
              className="input-base"
              value={form.password}
              onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
              data-testid="login-password"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            className="btn-primary w-full disabled:opacity-60"
            data-testid="login-submit"
          >
            {submitting ? "Giriş yapılıyor..." : (<><LogIn className="h-4 w-4" /> Giriş Yap <ArrowRight className="h-4 w-4" /></>)}
          </button>
        </form>

        <p className="mt-6 text-center text-xs text-muted-foreground">© Focus Spor Kulübü · Yetkisiz girişler kayıt altına alınır.</p>
      </div>
    </div>
  );
}
